import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { theme } from './theme/theme';
import { Navbar } from './components/Layout/Navbar';
import { HomePage } from './pages/Home';
import { ProductsPage } from './pages/Products';
import { ServicesPage } from './pages/Services';
import { Footer } from './components/Layout/Footbar';
import LegalPage from './pages/Legal';
import GameDevPage from './pages/GamePage';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/gamedev" element={<GameDevPage />} />
          <Route path="/legal" element={<LegalPage/>}/>
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
};

export default App;